import type { AxiosInstance } from 'axios';
import axios from 'axios';

import { environment } from '../config';
import { Api } from './api';
import { TokensService } from './tokens.service';
import { UnauthorizedApi } from './unauthorized.api';
import { RefreshTokensUseCase } from './use-cases/refresh-token.usecase';

// Create axios instance with default config
const httpClient: AxiosInstance = axios.create({
  baseURL: `${environment.backend}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

const unauthorizedApi = new UnauthorizedApi(httpClient);

const tokensService = new TokensService(
  new RefreshTokensUseCase(async (refreshToken) =>
    unauthorizedApi.refreshToken({ refreshToken })
  )
);

const $$api = new Api(httpClient, tokensService);

tokensService.use(httpClient);

export { $$api };
